import React from 'react';

interface ShowIfProps {
  condition: boolean;
  children: React.ReactNode;
  alternative?: React.ReactNode;
}

export const ShowIf: React.FC<ShowIfProps> = ({ condition, children, alternative }) =>
  condition ? <>{children}</> : (alternative ?? null);
